import { GET_PHOTOGRAPHERS_SUCCESS, GET_COMPETITION_SUCCESS } from './types';

const initialState = {
  data: [],
  memberData: [],
  priceData: [],
};

const defaultKeys = {
  name: '',
  email: '',
  first_name: '',
  last_name: '',
  county: '',
  place: '',
  gender: '',
  born: 0,
  died: 0,
  member_to: 0,
  member_from: 0,
  prices: [],
  positions: [],
};

const merge = (members, priceWinners) => {
  const photographers = [];
  members.forEach(member => {
    const priceWinner = priceWinners.find(
      priceWinner => priceWinner.id === member.id,
    );
    photographers.push(Object.assign({}, defaultKeys, priceWinner, member));
  });
  priceWinners.forEach(priceWinner => {
    const member = members.find(member => member.id === priceWinner.id);
    if (!photographers.find(member => member.id === priceWinner.id)) {
      photographers.push(Object.assign({}, defaultKeys, priceWinner, member));
    }
  });
  return photographers;
};

function reducer(state = initialState, action) {
  if (!action || !action.type) {
    return state;
  }
  switch (action.type) {
    case GET_PHOTOGRAPHERS_SUCCESS:
      return {
        ...state,
        memberData: action.data,
        data: merge(action.data, state.priceData),
      };
    case GET_COMPETITION_SUCCESS:
      return {
        ...state,
        priceData: action.data,
        data: merge(
          state.memberData,
          action.data.map(p => {
            if (p.prices === null) {
              p.prices = [];
            }
            return p;
          }),
        ),
      };
    default:
      return state;
  }
}

export { reducer as default };



// WEBPACK FOOTER //
// ./src/photographers/reducer.js